<template>
<div class="z-main">
 	<header class="z-header">
		<div><router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>信息中心</div>
		<div><img v-on:click="updata" src="../../assets/gengxin.png"></div>
	</header>
	<div class="z-body">
	<section>
	  <v-tabs centered dark>
		<v-tabs-slider color="red"></v-tabs-slider>

		<v-tab v-on:click="changeTab(0)" style="width: 50%;background-color: #28293D;" href="#tab-1">
		  未读
		  <div style="width: 19px;height: 19px;border-radius: 50%;background-color: crimson;margin-left: 8px">{{total0}}</div>
		</v-tab>

		<v-tab v-on:click="changeTab(1)" style="width: 50%;background-color: #28293D;" href="#tab-2">
		  已读
		</v-tab>

		<v-tab-item id="tab-1">
		  <v-card flat>
			<section class="finan">
			  <load-more :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :bottomPullText='bottomText' :auto-fill="false" @bottom-status-change="handleBottomChange" ref="loadmore">
				<section style="background-color: #28293D;border-top: 1px solid rgb(48,48,48);">
				  <div v-for="(item,index) in dataList0" class="dataTapBox">
					<div>
					  <div style="width: 55%;overflow: hidden;text-overflow: ellipsis;height: 30px;white-space: nowrap;">{{item.title}}</div>
					  <div style="width: 35%;overflow: hidden;text-overflow: ellipsis;height: 30px;white-space: nowrap;">{{item.atime}}</div>
					</div>
					<div>
					  <div style="width: 60%;height: 50px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;">
						<span v-html="item.content"></span>
					  </div>
					  <div v-bind:style="item.mark==1? 'background-color: gray':''" class="markupBtn" v-on:click="markRead(item.id,index)">标记已读</div>
					</div>
				  </div>
				</section>
			  </load-more>
			</section>

		  </v-card>
		</v-tab-item>

		<v-tab-item id="tab-2">
		  <v-card flat>
			<section class="finan">
			  <load-more :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :bottomPullText='bottomText' :auto-fill="false" @bottom-status-change="handleBottomChange" ref="loadmore">
				<section style="background-color: #28293D;border-top: 1px solid rgb(48,48,48);">
				  <div v-for="item in dataList1" class="dataTapBox">
					<div>
					  <div style="width: 55%;overflow: hidden;text-overflow: ellipsis;height: 30px;white-space: nowrap;">{{item.title}}</div>
					  <div style="width: 35%;overflow: hidden;text-overflow: ellipsis;height: 30px;white-space: nowrap;">{{item.atime}}</div>
					</div>
					<div>
					  <div style="width: 100%;height: 50px;text-overflow: ellipsis;">
						<span v-html="item.content"></span>
					  </div>
					</div>
				  </div>
				</section>
			  </load-more>
			</section>
		  </v-card>
		</v-tab-item>

	  </v-tabs>
	</section>
	</div>
  </div>
</template>

<script>
  import loadMore from "../../components/loadMore.vue"
	export default {
		inject:['reload'],
		name: 'messageCenter',
		data() {
			return {
			  token:"",
			  dataList0:[],
			  nowPage0:1,
			  total0:0,
			  dataList1:[],
			  nowPage1:1,
			  total1:0,
			  scrollHeight: 0,
			  scrollTop: 0,
			  containerHeight: 0,
			  loading: false,
			  allLoaded: false,
			  bottomText: '上拉加载更多...',
			  bottomStatus: '',
			  totalCount: '',
			  nowTabComtent:0,
			  markupList:[]
			}
		},
		mounted() {
		  this.get('api/Notice/Lists.html', {
			page:this.nowPage0,
			read:0
		  }).then((res) => {
			
			if(res.code==0){
			  this.dataList0=res.data.data
			  this.total0=res.data.total
			}
		  })
		  this.post('api/Notice/Lists.html', {
			page:this.nowPage1,
			read:1
		  }).then((res) => {
			
			if(res.code==0){
			  this.dataList1=res.data.data
			  this.total1=res.data.total
			}
		  })
		},
		methods: {
		  _scroll: function(ev) {
			ev = ev || event;
			this.scrollHeight = this.$refs.innerScroll.scrollHeight;
			this.scrollTop = this.$refs.innerScroll.scrollTop;
			this.containerHeight = this.$refs.innerScroll.offsetHeight;
		  },
		  loadBottom: function() {
			let _this=this;
			this.$store.commit('layer','数据加载中')
			if(this.nowTabComtent==0){
			  if (this.total0 == this.dataList0.length) {
				setTimeout(function () {
				  _this.$store.commit('layer','无数据')
				},1000)
			  }else {
				this.post('api/Notice/Lists.html', {
				  page:this.nowPage0+1,
				  read:0
				}).then((res) => {
				  
				  setTimeout(function () {
					if(res.code==0){
					  _this.nowPage0=res.data.page
					  for(let i=0;i<res.data.data.length;i++){
						_this.dataList0.push(res.data.data[i])
					  }
					  _this.$store.commit('layer','加载完成')
					}else {
					  _this.$store.commit('layer','加载失败')
					}
				  },1000)
				})
			  }
			}else if(this.nowTabComtent==1){
			  if (this.total1 == this.dataList1.length) {
				setTimeout(function () {
				  _this.$store.commit('layer','无数据')
				},1000)
			  }else {
				this.post('api/Notice/Lists.html', {
				  page:this.nowPage1+1,
				  read:1
				}).then((res) => {
				  
				  setTimeout(function () {
					if(res.code==0){
					  _this.nowPage1=res.data.page
					  for(let i=0;i<res.data.data.length;i++){
						_this.dataList1.push(res.data.data[i])
					  }
					  _this.$store.commit('layer','加载完成')
					}else {
					  _this.$store.commit('layer','加载失败')
					}
				  },1000)
				})
			  }
			}
		  },
		  handleBottomChange(status) {
			this.bottomStatus = status;
		  },
		  changeTab:function (e) {
			if(e==0){
			  this.nowTabComtent=0
			}else if(e==1){
			  this.nowTabComtent=1
			}
		  },
		  updata:function () {
			this.reload()
		  },
		  markRead:function (e,n) {
			this.post('api/Notice/Read.html', {
			  id:e
			}).then((res) => {
			  this.$store.commit('layer',res.msg)
			  if(res.code==0){
				this.dataList0[n].mark=1
				
			  }
			})
		  }
		},
		components:{
		  'load-more': loadMore
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a{
	color: lightgray;
	text-decoration: none;
  }
  .hearIcon{
	width:24px;
	height:24px;
  }
  .dataTapBox{
	margin: 10px;
	padding: 10px 8px 18px 8px;
	border-radius: 6px;
	background-color: #424355;
	font-size: 13px
  }
  .dataTapBox >div{
	display: flex;
	justify-content: space-between
  }
  .markupBtn{
	width: 100px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	background-color: rgb(219,72,72);
	border-radius: 6px;
	font-size: 19px;
	margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/my/messageCenter.vue